import { render } from "./UserName.vue?vue&type=template&id=e9c3c48a&scoped=true&bindings={\"user\":\"props\",\"reportable\":\"props\",\"modalName\":\"setup-maybe-ref\",\"data\":\"setup-maybe-ref\"}"
import script from "./UserName.vue?vue&type=script&lang=js"
export * from "./UserName.vue?vue&type=script&lang=js"

import "./UserName.vue?vue&type=style&index=0&id=e9c3c48a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e9c3c48a"

export default script